import React, { useEffect, useRef } from "react";
import { FaCheck } from "react-icons/fa";
// import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import missionImg from "../AboutUsPage/images/missionImg.png";
import visionImg from "../AboutUsPage/images/visionImg.png";

const Our_Mission_Vision = () => {
    const missionRef = useRef(null);
    const visionRef = useRef(null);

    useEffect(() => {
        const reveal = (el) => el.classList.add("in");
        const opts = { threshold: 0.18, rootMargin: "0px 0px -40px 0px" };
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    reveal(e.target);
                    // unobserve once animated
                    io.unobserve(e.target);
                }
            });
        }, opts);

        if (missionRef.current) io.observe(missionRef.current);
        if (visionRef.current) io.observe(visionRef.current);

        return () => io.disconnect();
    }, []);

    const missionPoints = [
        "WhatsApp-first platform for unified workflows.",
        "AI tools for smart communication and insights.",
        "Streamlines complex processes effortlessly.",
        "Enables fast, scalable digital growth.",
        "Inclusive and mobile-first for all users.",
        "Integrates easily with CRMs and payments.",
    ];

    const visionPoints = [
        "10 built-in suites for logistics, billing, commerce, and more.",
        "Conversations power all business and government workflows.",
        "A unified platform replacing disconnected tools.",
        "Automation that feels seamless and intuitive.",
        "Optimized systems for every sector, everywhere.",
    ];

    const h2Style = {
        fontSize: "44px",
        fontFamily: "'Inter', sans-serif",
        fontWeight: 650,
        color: "#1C1C1C",
        lineHeight: 1.2,
    };

    const subStyle = {
        fontSize: "20px",
        color: "#6B6B6B",
        fontWeight: 400,
        fontFamily: "'Inter', sans-serif",
        lineHeight: 1.2,
    };

    //  Check Icon wrapper (unchanged)
    const CheckIcon = () => (
        <div
            style={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                backgroundColor: "#E6F1FB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                marginTop: 2,
            }}
        >
            <FaCheck size={12} color="#054E91" /> 
            {/* <IoMdCheckmarkCircleOutline size={20} color="#054E91" /> */}
        </div>
    );

    return (
        <section
            className="py-4 position-relative"
            style={{
                overflow: "hidden",
                background: "linear-gradient(135deg, #f1f8feff 0%, #F4F9FF 100%)",
                marginTop: 100,
            }}
        >
            <div
                className="px-3 px-md-4 mx-auto position-relative"
                style={{ maxWidth: "72%", zIndex: 1 }}
            >
                {/* ===== Mission (fade-in from LEFT) ===== */}
                <div
                    ref={missionRef}
                    className="reveal-left d-flex align-items-center"
                    style={{ gap: 36, flexWrap: "wrap" }}
                >
                    {/* Left: text */}
                    <div style={{ flex: "1 1 480px", minWidth: 320 }}>
                        <h2 style={h2Style}>Our Mission</h2>
                        <p className="mt-2" style={subStyle}>
                            Simplifying work with AI, automation and WhatsApp-first solutions.
                        </p>

                        <div style={{ marginTop: 12 }}>
                            {missionPoints.map((t, i) => (
                                <div
                                    key={i}
                                    className="d-flex align-items-start"
                                    style={{ gap: 12, marginBottom: 12 }}
                                >
                                    <CheckIcon />
                                    <span
                                        style={{
                                            fontSize: 17,
                                            color: "#6B6B6B",
                                            lineHeight: 1.45,
                                            fontFamily: "'Inter', sans-serif",
                                        }}
                                    >
                                        {t}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right: image */}
                    <div style={{ flex: "1 1 460px", minWidth: 320 }}>
                        <img
                            src={missionImg}
                            alt="Our Mission"
                            style={{
                                width: "100%",
                                maxWidth: "680px",
                                height: "auto",
                                display: "block",
                            }}
                        />
                    </div>
                </div>

                {/* ===== Vision (fade-in from RIGHT) ===== */}
                <div
                    ref={visionRef}
                    className="reveal-right d-flex align-items-center"
                    style={{ marginTop: 60, gap: 36, flexWrap: "wrap" }}
                >
                    {/* Left: image */}
                    <div style={{ flex: "1 1 460px", minWidth: 320 }}>
                        <img
                            src={visionImg}
                            alt="Our Vision"
                            style={{
                                width: "100%",
                                maxWidth: "680px",
                                height: "auto",
                                display: "block",
                            }}
                        />
                    </div>

                    {/* Right: text */}
                    <div style={{ flex: "1 1 480px", minWidth: 320, paddingLeft: "24px" }}>
                        <h2 style={h2Style}>Our Vision</h2>
                        <p className="mt-2" style={subStyle}>
                            One vision, one platform-making WhatsApp the hub of all workflows.
                        </p>

                        <div style={{ marginTop: 12 }}>
                            {visionPoints.map((t, i) => (
                                <div
                                    key={i}
                                    className="d-flex align-items-start"
                                    style={{ gap: 12, marginBottom: 12 }}
                                >
                                    <CheckIcon />
                                    <span
                                        style={{
                                            fontSize: 17,
                                            color: "#6B6B6B",
                                            lineHeight: 1.45,
                                            fontFamily: "'Inter', sans-serif",
                                        }}
                                    >
                                        {t}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* tiny CSS for reveals */}
            <style>{`
        .reveal-left, .reveal-right {
          opacity: 0;
          transform: translate3d(0,0,0);
          will-change: transform, opacity;
          transition: transform 600ms ease, opacity 600ms ease;
        }
        .reveal-left  { transform: translateX(-40px); }
        .reveal-right { transform: translateX( 40px); }

        .reveal-left.in,
        .reveal-right.in {
          opacity: 1;
          transform: translateX(0);
        }
      `}</style>
        </section>
    );
};

export default Our_Mission_Vision;
